import { ReactNode } from 'react';

import styles from './table.module.css';

export type TableCellProps = {
	children: ReactNode | ReactNode[];
};

export const TableCell = ({ children }: TableCellProps) => <td className={styles.cell}>{children}</td>;
